import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CartProvider } from './CartContext';

import * as Sentry from '@sentry/react';

// ✅ Initialize Sentry at the top
Sentry.init({
  dsn: 'https://cc00b138accff3a61a55b69ec598e0f6@o4509589036859392.ingest.us.sentry.io/4509589043150848',
  sendDefaultPii: true,
  tracesSampleRate: 1.0, // Optional: performance monitoring
});

const root = ReactDOM.createRoot(document.getElementById('root'));

// ✅ Wrap App with both Sentry ErrorBoundary and CartProvider
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={<p>Something went wrong. Please refresh the page.</p>}
    >
      <CartProvider>
        <App />
      </CartProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// Optional: Performance logging
reportWebVitals();
